<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 40 40" width="20">
    <path d="M38 12.83l-2.83-2.83-11.17 11.17-11.17-11.17-2.83 2.83 11.17 11.17-11.17 11.17 2.83 2.83 11.17-11.17 11.17 11.17 2.83-2.83-11.17-11.17z" fill="gray"/>
    <path d="M0 0h48v48h-48z" fill="none"/>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>

<style></style>
